/**
 * LAL/model metadata is enriched on GET audience, not on PUT.
 * After save/refresh, merge those fields from the pre-update audience so the
 * Model step does not regress to "Audience never modeled" (ACT-2793).
 */
const LAL_MODEL_FIELDS_TO_PRESERVE = [
  'lalModelStatus',
  'lalModelCompletedAt',
  'lalModelId',
  'lalAudienceCount',
  'valueCompositions',
  'lalModelType',
  'exportHistory',
] as const;

/**
 * Merges LAL/model fields from the previous audience into the API response when
 * the response omits them (undefined). Explicit null from the API is preserved.
 *
 * @param updatedAudienceFromApi - Audience payload returned by the update/refresh API
 * @param previousAudience - Audience state before the update (may hold enriched LAL fields)
 * @returns Audience with omitted LAL fields filled from the previous audience
 */
export function preserveAudienceLalModelFields(
  updatedAudienceFromApi: Record<string, unknown> | null | undefined,
  previousAudience: Record<string, unknown> | null | undefined
): Record<string, unknown> {
  const nextAudience = { ...(updatedAudienceFromApi || {}) };

  for (const field of LAL_MODEL_FIELDS_TO_PRESERVE) {
    if (
      nextAudience[field] === undefined &&
      previousAudience?.[field] != null
    ) {
      nextAudience[field] = previousAudience[field];
    }
  }

  return nextAudience;
}
